module.exports = __webpack_public_path__ + "static/media/logo.0df10774.png";